import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import Icon from '../components/Icon'

function NotFound() {
  const navigate = useNavigate()
  useEffect(() => window.scrollTo(0, 0), [])

  return (
    <main className="view">
      <div className="wrap subpage">
        <div className="notfound">
          <div className="nf-code">404</div>
          <h1>Page not found</h1>
          <p>The page you're looking for doesn't exist or may have moved. Let's get you back on track.</p>

          <div className="nf-actions">
            <button className="btn btn-c" onClick={() => navigate('/')}>
              <Icon name="arrow-right" size={18} style={{ color: '#fff' }} />
              Back to home
            </button>
            <button className="btn btn-soft" onClick={() => navigate('/#tools')}>Browse all tools</button>
          </div>

          <div className="nf-links">
            <span>Popular:</span>
            <a onClick={() => navigate('/tool/compress')}>Compress Image</a>
            <a onClick={() => navigate('/tool/merge')}>Merge PDF</a>
            <a onClick={() => navigate('/tool/pdf2word')}>PDF to Word</a>
            <a onClick={() => navigate('/tool/removebg')}>Remove Background</a>
          </div>
        </div>
      </div>
    </main>
  )
}

export default NotFound
